// psychological-interventions
const counselingAlgorithm1 =
    "/docs/guidelines/psychological-interventions/1_Алгоритм_психологического_консультирования.pdf";
const counselingAlgorithm2 =
    "/docs/guidelines/psychological-interventions/2_Алгоритм_психологического_консультирования.pdf";
const counselingAlgorithm3 =
    "/docs/guidelines/psychological-interventions/3_Алгоритм_психологического_консультирования.pdf";
const counselingAlgorithm4 =
    "/docs/guidelines/psychological-interventions/4_Алгоритм_психологического_консультирования.pdf";
const counselingAlgorithm5 =
    "/docs/guidelines/psychological-interventions/5_Алгоритм_психологического_консультирования.pdf";
const counselingAlgorithm6 =
    "/docs/guidelines/psychological-interventions/6_Алгоритм_психологического_консультирования.pdf";

// psychological-interventions
const preparationWorkWithStudents = "/docs/guidelines/psychological-interventions/Вложение_1_Работа_с_обучающимися.pdf";
const preparationWorkWithParents = "/docs/guidelines/psychological-interventions/Вложение_2_Работа_с_родителями.pdf";
const preparationWorkWithTeachers = "/docs/guidelines/psychological-interventions/Вложение_3_Работа с педагогами.pdf";
const notAfraidOfInterview = "/docs/guidelines/psychological-interventions/Конспект_Я_не_боюсь_собеседования.pdf";
const examPreparationProgram =
    "/docs/guidelines/psychological-interventions/Программа_Психологическая_подготовка_к_ЕГЭ.pdf";

// psychological-interventions
const aggressionCorrectionShort =
    "/docs/guidelines/psychological-interventions/Программа_коррекции_агрессивного_поведения_короткая.docx";
const anxietyAssessmentMethod =
    "/docs/guidelines/psychological-interventions/Психодиагностическая_методика_для_многомерной_оценки_детской_тревожности.pdf";
const anxietyAndWorry = "/docs/guidelines/psychological-interventions/Тревога_и_беспокойство.pdf";
const anxietyAndFears = "/docs/guidelines/psychological-interventions/Тревога_и_страхи.pdf";
const angerManagement = "/docs/guidelines/psychological-interventions/Управляем_гневом_РТ.pdf";
const schoolAnxiety = "/docs/guidelines/psychological-interventions/Школьная_тревожность.pdf";

// psychological-interventions
const antiBullyingWorkbook =
    "/docs/guidelines/psychological-interventions/Антибуллинг_Рабочая_тетрадь_для_учащихся_11_13_лет.pdf";
const groupSessionNoBullying =
    "/docs/guidelines/psychological-interventions/Групповое_занятие_Школьному_буллингу_нет.docx";
const gamesAndExercisesForBullyingPrevention =
    "/docs/guidelines/psychological-interventions/Игры_и_упражнения_по_профилактике_травли.docx";
const conflictsInOurLife = "/docs/guidelines/psychological-interventions/Конфликты_в_нашей_жизни.doc";
const schoolWithoutConflictsCollection =
    "/docs/guidelines/psychological-interventions/Сборник_Школа_без_конфликтов.pdf";
const groupCohesionExercises =
    "/docs/guidelines/psychological-interventions/Цикл_занятий_Как_сплотить_детей_в_младшей_группе.doc";

// psychological-interventions-hyperactivity
const hyperactiveChildrenCorrection =
    "/docs/guidelines/psychological-interventions/Гиперактивные_дети_Коррекция_психомоторного_развития.pdf";
const overcomingADHD = "/docs/guidelines/psychological-interventions/Победа_над_СДВГ.pdf";

// psychological-interventions-violent
const artPracticesInCrisisFamilies =
    "/docs/guidelines/psychological-interventions/Арт_практики_в_работе_с_кризисными_семьями.pdf";
const psychologicalHelpForAbusedChildren =
    "/docs/guidelines/psychological-interventions/Психологическая_помощь_детям_пострадавшим_от_насилия.pdf";

// psychological-interventions-support
const tipsToOvercomeAnxiety =
    "/docs/guidelines/psychological-interventions/10_советов,_как_преодолеть_тревогу_страх_и_беспокойство.pdf";
const constantSkillsDuringStress = "/docs/guidelines/psychological-interventions/Важные_навыки_в_периоды_стресса.pdf";
const keyToSelfEmotionsUnderControl =
    "/docs/guidelines/psychological-interventions/Ключ_к_себе_Берем_эмоции_под_контроль.pdf";
const surviveGriefAcceptanceNotebook1 =
    "/docs/guidelines/psychological-interventions/Пережить_горе_Принятие_Тетрадь_1.pdf";
const surviveGriefHeavyEmotionsNotebook2 =
    "/docs/guidelines/psychological-interventions/Пережить_горе_Тяжелые_эмоции_Тетрадь_2.pdf";
const surviveGriefFearNotebook3 = "/docs/guidelines/psychological-interventions/Пережить горе_Страх_Тетрадь_3.pdf";
const calmWorkbookGrades1To4 = "/docs/guidelines/psychological-interventions/Рабочая_тетрадь_Я_спокоен_1-4 классы.docx";
const stayCalmTeenagers = "/docs/guidelines/psychological-interventions/Спокойно_ты_справишься_Подростки.pdf";

// psychological-interventions-play-therapy
const correctionalFairyTalesDuringDivorce =
    "/docs/guidelines/psychological-interventions/Психокорекционные_сказки_при_разводе_родителей.docx";
const rainbowOfEmotionsProgram = "/docs/guidelines/psychological-interventions/Радуга_эмоций_Программа.pdf";
const collectionOfPlayPracticesEmotionalIntelligence =
    "/docs/guidelines/psychological-interventions/Сборник_игровых_практик_Эмоциональный_интеллект_детей.pdf";
const fairyTaleTherapyWithSpecialChild =
    "/docs/guidelines/psychological-interventions/Сказкотерапия_с_особым_ребенком.pdf";
const cycleOfSessionsWithElementsOfFairyTaleTherapy =
    "/docs/guidelines/psychological-interventions/Цикл_занятий_с_элементами_сказкотерапии.pdf";

// psychological-interventions-suicide-risk
const individualProgram = "/docs/guidelines/psychological-interventions/Индивидуальная программа.docx";
const howToHelpThoseWhoDontWantToLive =
    "/docs/guidelines/psychological-interventions/Как_помочь_тем_кто_не_хочет_жить.pdf";
const methodsForSuicidePreventionPrograms =
    "/docs/guidelines/psychological-interventions/Метод_рекоменд_по_профил_суацидов_с_названиями_программ.pdf";
const guidelinesForDiagnosingSuicideAmongChildren =
    "/docs/guidelines/psychological-interventions/Методич._рекомендации_по_диагностике_суицида_среди_детей_и_подростков.pdf";
const guidelinesForDiagnosingSuicide =
    "/docs/guidelines/psychological-interventions/Методические_рекомендации_по_диагностике_суицида.pdf";
const overcomingSuicidalThoughtsAmongTeens =
    "/docs/guidelines/psychological-interventions/Преодоление_суицидальных_мыслей_у_подростков.epub";
const suicidePreventionProgramForTeens =
    "/docs/guidelines/psychological-interventions/Программа_Профилактики_суицидального_поведения_подростков.doc";
const suicidePrevention = "/docs/guidelines/psychological-interventions/Профилактика суицида.pdf";
const suicideAlgorithmForTeachers = "/docs/guidelines/psychological-interventions/Суицид. Алгоритм для педагогов.pdf";
const suicideHandbookForPsychologistsAndSocialPedagogues =
    "/docs/guidelines/psychological-interventions/Суицид_Методичка_для_психологов_и_соцпедагогов.pdf";
const suicidalBehaviorAmongTeens = "/docs/guidelines/psychological-interventions/Суицидальное_поведение_подростков.pdf";

// psychological-interventions-lnr-dnr
const guidelinesPreventingIllegalActionsRisks =
    "/docs/guidelines/psychological-interventions/Методические_рекомендации_Предупреждение_рисков_противоправных_деяний.pdf";
const memoChildrenFromLNRDNRUkraine =
    "/docs/guidelines/psychological-interventions/Памятка_Дети_из_ДНР_ЛНР_Украины.pdf";
const memoForTeensDuringUnstableWorldSituation =
    "/docs/guidelines/psychological-interventions/Памятка_Для_подростков_В_период_нестабильной_ситуации_в_мире.pdf";
const memoForPsychologistsDuringUnstableWorldSituation =
    "/docs/guidelines/psychological-interventions/Памятка_Для_психологов_В_период_нестабильной_ситуации_в_мире.pdf";
const memoForParentsDuringUnstableWorldSituation =
    "/docs/guidelines/psychological-interventions/Памятка_Для_родителей_В_период_нестабильной_ситуации_в_мире.pdf";
const memoForTeachersDuringUnstableWorldSituation =
    "/docs/guidelines/psychological-interventions/Памятка_Для_учителей_В_период_нестабильной_ситуации_в_мире.pdf";
const memoEmotionalStateStabilization =
    "/docs/guidelines/psychological-interventions/Памятка_Стабилизация эмоционального состояния.pdf";
const psychologicalSupportProgramForChildrenForcedMigrants =
    "/docs/guidelines/psychological-interventions/Программа_психологического_сопровождения_детей_вынужденных_мигрантов.docx";

// psychological-interventions-language-work
const guidelinesLanguageAndSocioculturalIntegration =
    "/docs/guidelines/psychological-interventions/Методические_рекомендации_Языковая_и_социокультурная_интеграция.pdf";
const assessmentOfLanguagePreparationLevel =
    "/docs/guidelines/psychological-interventions/Оценка_уровня_языковой_подготовки.pdf";
const programRKI = "/docs/guidelines/psychological-interventions/Программа_РКИ.pdf";
const recommendationsForConductingRKIDiagnostics =
    "/docs/guidelines/psychological-interventions/Рекомендации_по_проведению_диагностики_РКИ.pdf";
const languageAdaptationForChildrenFromMigrantFamilies =
    "/docs/guidelines/psychological-interventions/Языковая_адаптация_детей_из_семей_мигрантов.pdf";

export const psychologicalInterventions = {
    folders: [
        {
            title: "Алгоритм психологической работы СВО",
            link: "/psychological-interventions-algorithm",
        },
        {
            title: "Психологическая подготовка к ГИА и ЕГЭ",
            link: "/psychological-interventions-preparation",
        },
        {
            title: "Работа с агрессией и тревожностью",
            link: "/psychological-interventions-aggression",
        },
        {
            title: "Работа с буллингом",
            link: "/psychological-interventions-bulling",
        },
        {
            title: "Работа с вынужденными мигрантами",
            link: "/psychological-interventions-migrant",
        },
        {
            title: "Работа с гиперактивностью",
            link: "/psychological-interventions-hyperactivity",
        },
        {
            title: "Работа с пострадавшими от насилия",
            link: "/psychological-interventions-violent",
        },
        {
            title: "Самопомощь для подростков",
            link: "/psychological-interventions-support",
        },
        {
            title: "Сказко- и игротерапия",
            link: "/psychological-interventions-play-therapy",
        },
        {
            title: "Сопровождение при суицидальном риске",
            link: "/psychological-interventions-suicide-risk",
        },
    ],
};

export const psychologicalInterventionsAlgorithm = {
    files: [
        {
            title: "Алгоритм психологического консультирования 1",
            file: counselingAlgorithm1,
            fileName: "1_Алгоритм_психологического_консультирования.pdf",
        },
        {
            title: "Алгоритм психологического консультирования 2",
            file: counselingAlgorithm2,
            fileName: "2_Алгоритм_психологического_консультирования.pdf",
        },
        {
            title: "Алгоритм психологического консультирования 3",
            file: counselingAlgorithm3,
            fileName: "3_Алгоритм_психологического_консультирования.pdf",
        },
        {
            title: "Алгоритм психологического консультирования 4",
            file: counselingAlgorithm4,
            fileName: "4_Алгоритм_психологического_консультирования.pdf",
        },
        {
            title: "Алгоритм психологического консультирования 5",
            file: counselingAlgorithm5,
            fileName: "5_Алгоритм_психологического_консультирования.pdf",
        },
        {
            title: "Алгоритм психологического консультирования 6",
            file: counselingAlgorithm6,
            fileName: "6_Алгоритм_психологического_консультирования.pdf",
        },
    ],
};

export const psychologicalInterventionsPreparation = {
    files: [
        {
            title: "Работа с обучающимися",
            file: preparationWorkWithStudents,
            fileName: "Вложение_1_Работа_с_обучающимися.pdf",
        },
        {
            title: "Работа с родителями",
            file: preparationWorkWithParents,
            fileName: "Вложение_2_Работа_с_родителями.pdf",
        },
        {
            title: "Работа с педагогами",
            file: preparationWorkWithTeachers,
            fileName: "Вложение_3_Работа с педагогами.pdf",
        },
        {
            title: "Я не боюсь собеседования (Конспект)",
            file: notAfraidOfInterview,
            fileName: "Конспект_Я_не_боюсь_собеседования.pdf",
        },
        {
            title: "Программа: Психологическая подготовка к ЕГЭ",
            file: examPreparationProgram,
            fileName: "Программа_Психологическая_подготовка_к_ЕГЭ.pdf",
        },
    ],
};

export const psychologicalInterventionsAggression = {
    files: [
        {
            title: "Программа коррекции агрессивного поведения (короткая)",
            file: aggressionCorrectionShort,
            fileName: "Программа_коррекции_агрессивного_поведения_короткая.docx",
        },
        {
            title: "Психодиагностическая методика для многомерной оценки детской тревожности",
            file: anxietyAssessmentMethod,
            fileName: "Психодиагностическая_методика_для_многомерной_оценки_детской_тревожности.pdf",
        },
        {
            title: "Тревога и беспокойство",
            file: anxietyAndWorry,
            fileName: "Тревога_и_беспокойство.pdf",
        },
        {
            title: "Тревога и страхи",
            file: anxietyAndFears,
            fileName: "Тревога_и_страхи.pdf",
        },
        {
            title: "Управляем гневом",
            file: angerManagement,
            fileName: "Управляем_гневом_РТ.pdf",
        },
        {
            title: "Школьная тревожность",
            file: schoolAnxiety,
            fileName: "Школьная_тревожность.pdf",
        },
    ],
};

export const psychologicalInterventionsBulling = {
    files: [
        {
            title: "Антибуллинг: Рабочая тетрадь для учащихся 11-13 лет",
            file: antiBullyingWorkbook,
            fileName: "Антибуллинг_Рабочая_тетрадь_для_учащихся_11_13_лет.pdf",
        },
        {
            title: "Групповое занятие: Школьному буллингу - нет!",
            file: groupSessionNoBullying,
            fileName: "Групповое_занятие_Школьному_буллингу_нет.docx",
        },
        {
            title: "Игры и упражнения по профилактике травли",
            file: gamesAndExercisesForBullyingPrevention,
            fileName: "Игры_и_упражнения_по_профилактике_травли.docx",
        },
        {
            title: "Конфликты в нашей жизни",
            file: conflictsInOurLife,
            fileName: "Конфликты_в_нашей_жизни.doc",
        },
        {
            title: "Сборник: Школа без конфликтов",
            file: schoolWithoutConflictsCollection,
            fileName: "Сборник_Школа_без_конфликтов.pdf",
        },
        {
            title: "Цикл занятий: Как сплотить детей в младшей группе",
            file: groupCohesionExercises,
            fileName: "Цикл_занятий_Как_сплотить_детей_в_младшей_группе.doc",
        },
    ],
};

export const psychologicalInterventionsMigrant = {
    folders: [
        {
            title: "Памятки по работе с детьми из ЛНР и ДНР",
            link: "/psychological-interventions-lnr-dnr",
        },
        {
            title: "Языковая работа",
            link: "/psychological-interventions-language-work",
        },
    ],
};

export const psychologicalInterventionsHyperactivity = {
    files: [
        {
            title: "Гиперактивные дети: Коррекция психомоторного развития",
            file: hyperactiveChildrenCorrection,
            fileName: "Гиперактивные_дети_Коррекция_психомоторного_развития.pdf",
        },
        {
            title: "Победа над СДВГ",
            file: overcomingADHD,
            fileName: "Победа_над_СДВГ.pdf",
        },
    ],
};

export const psychologicalInterventionsViolent = {
    files: [
        {
            title: "Арт-практики в работе с кризисными семьями",
            file: artPracticesInCrisisFamilies,
            fileName: "Арт_практики_в_работе_с_кризисными_семьями.pdf",
        },
        {
            title: "Психологическая помощь детям, пострадавшим от насилия",
            file: psychologicalHelpForAbusedChildren,
            fileName: "Психологическая_помощь_детям_пострадавшим_от_насилия.pdf",
        },
    ],
};

export const psychologicalInterventionsSupport = {
    files: [
        {
            title: "10 советов, как преодолеть тревогу, страх и беспокойство",
            file: tipsToOvercomeAnxiety,
            fileName: "10_советов,_как_преодолеть_тревогу_страх_и_беспокойство.pdf",
        },
        {
            title: "Важные навыки в периоды стресса",
            file: constantSkillsDuringStress,
            fileName: "Важные_навыки_в_периоды_стресса.pdf",
        },
        {
            title: "Ключ к себе: Берем эмоции под контроль",
            file: keyToSelfEmotionsUnderControl,
            fileName: "Ключ_к_себе_Берем_эмоции_под_контроль.pdf",
        },
        {
            title: "Пережить горе: Принятие (Тетрадь 1)",
            file: surviveGriefAcceptanceNotebook1,
            fileName: "Пережить_горе_Принятие_Тетрадь_1.pdf",
        },
        {
            title: "Пережить горе: Тяжелые эмоции (Тетрадь 2)",
            file: surviveGriefHeavyEmotionsNotebook2,
            fileName: "Пережить_горе_Тяжелые_эмоции_Тетрадь_2.pdf",
        },
        {
            title: "Пережить горе: Страх (Тетрадь 3)",
            file: surviveGriefFearNotebook3,
            fileName: "Пережить горе_Страх_Тетрадь_3.pdf",
        },
        {
            title: "Рабочая тетрадь 'Я спокоен' (1-4 классы)",
            file: calmWorkbookGrades1To4,
            fileName: "Рабочая_тетрадь_Я_спокоен_1-4 классы.docx",
        },
        {
            title: "Спокойно, ты справишься (Подростки)",
            file: stayCalmTeenagers,
            fileName: "Спокойно_ты_справишься_Подростки.pdf",
        },
    ],
};

export const psychologicalInterventionsPlayTherapy = {
    files: [
        {
            title: "Психокоррекционные сказки при разводе родителей",
            file: correctionalFairyTalesDuringDivorce,
            fileName: "Психокорекционные_сказки_при_разводе_родителей.docx",
        },
        {
            title: "Радуга эмоций: Программа",
            file: rainbowOfEmotionsProgram,
            fileName: "Радуга_эмоций_Программа.pdf",
        },
        {
            title: "Сборник игровых практик: Эмоциональный интеллект детей",
            file: collectionOfPlayPracticesEmotionalIntelligence,
            fileName: "Сборник_игровых_практик_Эмоциональный_интеллект_детей.pdf",
        },
        {
            title: "Сказкотерапия с особым ребенком",
            file: fairyTaleTherapyWithSpecialChild,
            fileName: "Сказкотерапия_с_особым_ребенком.pdf",
        },
        {
            title: "Цикл занятий с элементами сказкотерапии",
            file: cycleOfSessionsWithElementsOfFairyTaleTherapy,
            fileName: "Цикл_занятий_с_элементами_сказкотерапии.pdf",
        },
    ],
};

export const psychologicalInterventionsSuicideRisk = {
    files: [
        {
            title: "Индивидуальная программа",
            file: individualProgram,
            fileName: "Индивидуальная программа.docx",
        },
        {
            title: "Как помочь тем, кто не хочет жить",
            file: howToHelpThoseWhoDontWantToLive,
            fileName: "Как_помочь_тем_кто_не_хочет_жить.pdf",
        },
        {
            title: "Методы по профилактике суицидов с названиями программ",
            file: methodsForSuicidePreventionPrograms,
            fileName: "Метод_рекоменд_по_профил_суацидов_с_названиями_программ.pdf",
        },
        {
            title: "Методические рекомендации по диагностике суицида среди детей и подростков",
            file: guidelinesForDiagnosingSuicideAmongChildren,
            fileName: "Методич._рекомендации_по_диагностике_суицида_среди_детей_и_подростков.pdf",
        },
        {
            title: "Методические рекомендации по диагностике суицида",
            file: guidelinesForDiagnosingSuicide,
            fileName: "Методические_рекомендации_по_диагностике_суицида.pdf",
        },
        {
            title: "Преодоление суицидальных мыслей у подростков",
            file: overcomingSuicidalThoughtsAmongTeens,
            fileName: "Преодоление_суицидальных_мыслей_у_подростков.epub",
        },
        {
            title: "Программа профилактики суицидального поведения подростков",
            file: suicidePreventionProgramForTeens,
            fileName: "Программа_Профилактики_суицидального_поведения_подростков.doc",
        },
        {
            title: "Профилактика суицида",
            file: suicidePrevention,
            fileName: "Профилактика суицида.pdf",
        },
        {
            title: "Суицид: Алгоритм для педагогов",
            file: suicideAlgorithmForTeachers,
            fileName: "Суицид. Алгоритм для педагогов.pdf",
        },
        {
            title: "Суицид: Методичка для психологов и соцпедагогов",
            file: suicideHandbookForPsychologistsAndSocialPedagogues,
            fileName: "Суицид_Методичка_для_психологов_и_соцпедагогов.pdf",
        },
        {
            title: "Суицидальное поведение подростков",
            file: suicidalBehaviorAmongTeens,
            fileName: "Суицидальное_поведение_подростков.pdf",
        },
    ],
};

export const psychologicalInterventionsLNRDNR = {
    files: [
        {
            title: "Методические рекомендации: Предупреждение рисков противоправных деяний",
            file: guidelinesPreventingIllegalActionsRisks,
            fileName: "Методические_рекомендации_Предупреждение_рисков_противоправных_деяний.pdf",
        },
        {
            title: "Памятка: Дети из ДНР, ЛНР, Украины",
            file: memoChildrenFromLNRDNRUkraine,
            fileName: "Памятка_Дети_из_ДНР_ЛНР_Украины.pdf",
        },
        {
            title: "Памятка для подростков: В период нестабильной ситуации в мире",
            file: memoForTeensDuringUnstableWorldSituation,
            fileName: "Памятка_Для_подростков_В_период_нестабильной_ситуации_в_мире.pdf",
        },
        {
            title: "Памятка для психологов: В период нестабильной ситуации в мире",
            file: memoForPsychologistsDuringUnstableWorldSituation,
            fileName: "Памятка_Для_психологов_В_период_нестабильной_ситуации_в_мире.pdf",
        },
        {
            title: "Памятка для родителей: В период нестабильной ситуации в мире",
            file: memoForParentsDuringUnstableWorldSituation,
            fileName: "Памятка_Для_родителей_В_период_нестабильной_ситуации_в_мире.pdf",
        },
        {
            title: "Памятка для учителей: В период нестабильной ситуации в мире",
            file: memoForTeachersDuringUnstableWorldSituation,
            fileName: "Памятка_Для_учителей_В_период_нестабильной_ситуации_в_мире.pdf",
        },
        {
            title: "Памятка: Стабилизация эмоционального состояния",
            file: memoEmotionalStateStabilization,
            fileName: "Памятка_Стабилизация эмоционального состояния.pdf",
        },
        {
            title: "Программа психологического сопровождения детей вынужденных мигрантов",
            file: psychologicalSupportProgramForChildrenForcedMigrants,
            fileName: "Программа_психологического_сопровождения_детей_вынужденных_мигрантов.docx",
        },
    ],
};

export const psychologicalInterventionsLanguageWork = {
    files: [
        {
            title: "Методические рекомендации: Языковая и социокультурная интеграция",
            file: guidelinesLanguageAndSocioculturalIntegration,
            fileName: "Методические_рекомендации_Языковая_и_социокультурная_интеграция.pdf",
        },
        {
            title: "Оценка уровня языковой подготовки",
            file: assessmentOfLanguagePreparationLevel,
            fileName: "Оценка_уровня_языковой_подготовки.pdf",
        },
        {
            title: "Программа РКИ",
            file: programRKI,
            fileName: "Программа_РКИ.pdf",
        },
        {
            title: "Рекомендации по проведению диагностики РКИ",
            file: recommendationsForConductingRKIDiagnostics,
            fileName: "Рекомендации_по_проведению_диагностики_РКИ.pdf",
        },
        {
            title: "Языковая адаптация детей из семей мигрантов",
            file: languageAdaptationForChildrenFromMigrantFamilies,
            fileName: "Языковая_адаптация_детей_из_семей_мигрантов.pdf",
        },
    ],
};
